import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { NameCell } from './name-cell';
import { messages } from '../messages';

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...messages.nameColumnHeader} />,
  Cell: NameCell,
  width: 2,
  minWidth: 150,
});
